import { dispatcher } from 'react-structure-admin';

export const PRESCRIPTION = 'PRESCRIPTION';
export const PRESCRIPTION_SHOW = 'PRESCRIPTION_SHOW';
export const PRESCRIPTION_CLOSE = 'PRESCRIPTION_CLOSE';

export const show = (forceDefaultPrescription = false) => (dispatch) => {
  dispatch(
    dispatcher.createAction(
      PRESCRIPTION_SHOW,
      'prescriptions',
      forceDefaultPrescription
    )
  );
};

export const close = () => (dispatch) => {
  dispatch(dispatcher.createAction(PRESCRIPTION_CLOSE, 'prescriptions'));
};
